































































import Vue, { PropType } from 'vue';
import { CandidateJobBuilder } from '~/utils/candidate/CandidateJobBuilder';
import { JobWorkExperience } from '~/utils/candidate';

// Components
import InfoBox from '~/components/profile/components/InfoBox.vue';
import WorkExperienceListItem from '../components/WorkExperienceListItem.vue';
import WorkExperienceListItemForm from '../components/WorkExperienceListItemForm.vue';
import { jobWorkExperienceValidator } from '~/utils/validators';

export default Vue.extend({
    name: 'WorkExperienceForm',
    components: { InfoBox, WorkExperienceListItem, WorkExperienceListItemForm },
    props: {
        builder: {
            type: Object as PropType<CandidateJobBuilder>,
            required: true,
        },
        loading: {
            type: Boolean,
            required: true,
        },
    },
    data() {
        return {
            workExperiences: this.builder.getWorkExperiences(),
            currentOpenWorkExperience: undefined as string | undefined,
        };
    },
    mounted() {
        this.$watch('workExperiences', this.builder.watchWorkExperiences());
    },
    computed: {
        isValid(): boolean {
            return (
                this.currentOpenWorkExperience === undefined &&
                this.workExperiences.every(we => jobWorkExperienceValidator(we))
            );
        },
    },
    methods: {
        addWorkExperience() {
            const we = {
                id: CandidateJobBuilder.generateId(),
                title: '',
                companyTitle: '',
                start: new Date(new Date().toISOString().slice(0, 7) + '-01'),
                end: null,
                location: null,
                description: null,
                isCurrentJob: false,
            };
            this.workExperiences.push(we);
            this.$nextTick(() => {
                this.openWorkExperience(we);
            });
        },
        removeWorkExperience(workExperience: JobWorkExperience) {
            this.closeWorkExperience();

            this.$nextTick(() => {
                const workExperiences = [...this.workExperiences];
                const idx = workExperiences.findIndex(we => we.id === workExperience.id);
                if (idx === -1) {
                    console.warn('WorkExperience not found', workExperience);
                    return;
                }
                workExperiences.splice(idx, 1);
                this.workExperiences = workExperiences;
            });
        },
        updateWorkExperience(workExperience: JobWorkExperience) {
            this.closeWorkExperience();
            const workExperiences = [...this.workExperiences];
            const idx = workExperiences.findIndex(we => we.id === workExperience.id);
            if (idx === -1) {
                console.warn('WorkExperience not found', workExperience);
                return;
            }
            workExperiences[idx] = { ...workExperience };
            this.workExperiences = workExperiences;
        },
        openWorkExperience(workExperience: JobWorkExperience) {
            this.currentOpenWorkExperience = workExperience.id;
        },
        closeWorkExperience() {
            this.currentOpenWorkExperience = undefined;
        },
    },
    watch: {
        isValid() {
            this.$emit('update:isValid', this.isValid);
        },
    },
});
